export interface IllustrationIdApi {
  illustrationId: string;
}

export let isGettedIllustrationIdDTO = (
  variable: unknown
): variable is IllustrationIdApi => {
  return (
    variable !== null &&
    variable !== undefined &&
    typeof variable === "object" &&
    "illustrationId" in variable &&
    typeof variable.illustrationId === "string"
  );
};
